export const getUnixTimestamp = (t = '') => (t ? String(t).substr(0, 10) : null);
